import React from "react";
import { ModalDelete } from "expano-components";
import { useMainList } from "components/MainList/context/provider";
import { deleteRackSchema } from "actions/warehouse_rack_schema";

const ModalDeleteRackType = ({ name, id, handleClose }) => {
  const { refetch } = useMainList();
  const handleDelete = () =>
    deleteRackSchema(id)
      .then(() => {
        refetch();
        handleClose();
      })
      .catch((err) => console.log(err));

  return (
    <ModalDelete
      name={`schemat ${name}?`}
      handleClose={handleClose}
      handleDelete={handleDelete}
    />
  );
};

export default ModalDeleteRackType;
